/**
 * 区分 linkedEntityType（attachments.linked_entity_type）
 * 出典：要件書 5.2
 */
export const LINKED_ENTITY_TYPE_VALUES = [
  'customer',
  'case',
  'transaction',
  'personnel',
  'contract',
  'formSubmission',
  'customerContact',
] as const;

export type LinkedEntityType = (typeof LINKED_ENTITY_TYPE_VALUES)[number];

export const LINKED_ENTITY_TYPE_LABELS: Readonly<Record<LinkedEntityType, string>> = {
  customer: '顧客',
  case: '案件',
  transaction: '取引',
  personnel: '要員',
  contract: '契約',
  formSubmission: 'フォーム回答',
  customerContact: '企業担当者（名刺）',
};
